import { Flex, Heading } from '@chakra-ui/react';

import { Carousel } from 'src/common/carousel';
import { EVENTS_ENG } from 'src/common/constants/englishLabels';
import { EVENTS_HIN } from 'src/common/constants/hindiLabels';
import { EventCard } from '../events/eventCard';
import React from 'react';
import { RecentEvents } from 'src/resources/DummyData';
import { RootState } from "src/store/store";
import { useSelector } from "react-redux";

const RegisteredSansthas: React.FC = () => {
    const globalInfo = useSelector((state: RootState) => state.globalInfo);
    const { globalLanguage } = globalInfo;
    const isHindiLabels = globalLanguage === "HI";


    return (
        <Flex direction="column" paddingY={{ base: 8, md: 12, lg: 14}} paddingX="2rem" background="rgba(255, 188, 120, 0.06)" height="100%">
            <Flex direction="row" alignItems="center" justifyContent="space-between" width="100%">
                <Heading as="h3" fontWeight="bold">{isHindiLabels ? EVENTS_HIN.RECENT_EVENTS : EVENTS_ENG.RECENT_EVENTS}</Heading>
                {/*<Button _hover={{ background: "#FF7E6B" }} color="white" background="#FF7E6B">*/}
                {/*    {isHindiLabels? BUTTONS_HIN.VIEW_ALL : BUTTONS_ENG.VIEW_ALL}*/}
                {/*</Button>*/}
            </Flex>
            <Carousel
                CardComponent={EventCard}
                eventList={RecentEvents}
                rows={1}
                slidesToShow={3}
            />
        </Flex>
    );
}

export default RegisteredSansthas;